import type { DocumentFieldEvidencePayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A field of a source document, `type: 'document_field'` discriminant. `documentId` is a relation,
 * resolved against `documentsStore.documents`; `label` and `value` are frozen at
 * generation time — never re-read from the live source document.
 */
class DocumentFieldEvidenceView {
	readonly type: 'document_field';
	readonly documentId: number;
	readonly key: string;
	readonly fieldUuid: string;
	readonly itemPath: readonly number[];
	readonly label: string;
	readonly value: string;

	constructor(payload: DocumentFieldEvidencePayload) {
		this.type = 'document_field';
		this.documentId = payload.document.id;
		this.key = payload.key;
		this.fieldUuid = payload.fieldUuid;
		this.itemPath = [...payload.itemPath];
		this.label = payload.label;
		this.value = payload.value;

		Object.freeze(this);
	}
}

export default DocumentFieldEvidenceView;
